import React, { useState } from 'react';


import { Link } from 'react-router-dom';

import { CSVLink } from 'react-csv';
import { TablePagination } from '../../../components/supply-chain/TablePagination/index.js';
//Import Breadcrumb

import useQuery from '../../../helpers/JIFI/useQuery';

import SupplyChainNav from '../../../components/supply-chain/nav.js';
import { Row } from '@shadcn/components/ui/row.jsx';
import { Col } from '@shadcn/components/ui/col.jsx';

import { Card, CardContent as CardBody } from '@shadcn/components/ui/card.jsx';
import { Button } from '@shadcn/components/ui/button.jsx';
import { Input } from '@shadcn/components/ui/input.jsx';
import { TableSkeleton } from '@shadcn/components/ui/table.jsx';

const FactoryList = () => {
  const dateString = new Date()
    .toDateString()
    .replace(' ', '-')
    .replace(' ', '-')
    .replace(' ', '-');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [factories, factoriesState] = useQuery({
    url: `/factory/all`,
    queryData: {
      page,
      perPage,
      searchTerm
    },
  });


  const handleKeyDown = (e) => {
    
    if (e.key === 'Enter' || e.keyCode === 13) {
      setSearchTerm(e.target.value);
    }
  }

  const factoryData = factories?.data;
  const count = factories?.totalCount;

  const csvData = [
    ['Code', 'Name', 'Total Stock Product'],
    ...(factoryData?.length > 0
      ? factoryData?.map((val) => [
          val.code,
          val.name,
          val?.variantLines?.length ?? 0,
        ])
      : []),
  ];
  return (
    <>
      <SupplyChainNav>
        <div>
          <Col className="w-full">
            <Card className="pt-6 mb-10">
              <CardBody>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Link to="/factories/create">
                    <div className="text-sm-right">
                      <Button
                        type="button"
                        variant="success"
                        className="btn-rounded waves-effect waves-light mb-2 mr-2"
                      >
                        <i className="mdi mdi-plus mr-1"></i> Create new{' '}
                      </Button>
                    </div>
                  </Link>
                  <CSVLink
                    style={{ float: 'right', marginBottom: '1.25rem' }}
                    data={csvData}
                    filename={`FACTORY-${dateString}.csv`}
                  >
                    <Button
                      type="button"
                      variant="secondary"
                      className="btn-md btn-rounded"
                    >
                      CSV
                    </Button>
                  </CSVLink>
                </div>
                <Row>
                <Col>
                    <label className="control-label">FILTER</label>
                    <Row>
                      <Col  className="sm:w-3/12">
                    
                        <div className="search-box mb-2 d-block">
                          <div className="position-relative">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Search..."
                              onKeyDown={handleKeyDown}
                            />
                          
                          </div>
                        </div>
                    
                      </Col>
                      
                    </Row>

                  </Col>
                </Row>
                
                  <div className="table-responsive">
                    <table className="table table-centered table-nowrap">
                      <tr>
                        <th>Code</th>
                        <th>Name</th>
                        <th className="text-center">Total Stock Product</th>
                      </tr>
                     {factoriesState === 'success' ?

                      <tbody>
                        {factoryData && factoryData.length > 0
                          ? factoryData.map((val, key) => {
                              return (
                                <tr>
                                  <td>
                                    <Link
                                      className="text-body font-weight-bold"
                                      to={`/factories/${val._id}`}
                                    >
                                      {val.code}
                                    </Link>
                                  </td>
                                  <td>{val.name}</td>
                                  <td className="text-center">
                                    {val?.variantLines?.length}
                                  </td>
                                </tr>
                              );
                            })
                          : []}
                      </tbody>
                      : <TableSkeleton columns={3} perPage={perPage} centerIndex={[2]} />
                      }
                    </table>
                  </div>
                
                <TablePagination
                  count={count}
                  page={page}
                  className={'mb-4'}
                  setPage={setPage}
                  perPage={perPage}
                  setPerPage={setPerPage}
                />
              </CardBody>
            </Card>
          </Col>
        </div>
      </SupplyChainNav>
    </>
  );
};

export default FactoryList;
